var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BusinessCrud',{attrs:{"title":"发票申请","columns":_vm.columns,"search-fields":_vm.searchFields,"form-fields":_vm.formFields,"list-api":_vm.getInvoiceList,"save-api":_vm.saveInvoice,"delete-api":_vm.deleteInvoice,"allow-create":false,"allow-delete":false,"defaults":{ invoiceType: '普票', status: '待开票', amount: 0 }}})
}
var staticRenderFns = []

export { render, staticRenderFns }